import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectDashboard } from "../Thunks/projectManagementThunk";
import { addAsyncResourceThunk } from "../helpers/asyncResource";
import { getWorkspaceTitleFromDashboardApiPayload } from "../../Pages/Projects/project-detail/dashboard/projectDashboard.mapper";

const initialState = {
  data: null,
  loading: false,
  error: null,
  /** Route project id (URL slug / UUID) the workspace title belongs to — cleared with {@link clearProjectDashboard}. */
  workspaceProjectId: null,
  /** Canonical project display name for header/tabs chrome; set from GET dashboard + optional list seed. */
  workspaceProjectName: null,
};

export const projectDashboardSlice = createSlice({
  name: "projectDashboard",
  initialState,
  reducers: {
    clearProjectDashboard: (state) => {
      state.data = null;
      state.error = null;
      state.loading = true;
      state.workspaceProjectId = null;
      state.workspaceProjectName = null;
    },
    /**
     * Seed header title from projects list before dashboard returns (GET all-projects / paginated row).
     * Dashboard `fulfilled` overwrites with API name when available.
     */
    seedWorkspaceProjectTitle: (state, action) => {
      const { projectId, name } = action.payload ?? {};
      if (projectId == null || name == null) return;
      const id = String(projectId).trim();
      const trimmed = String(name).trim();
      if (!id || !trimmed) return;
      state.workspaceProjectId = id;
      state.workspaceProjectName = trimmed;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchProjectDashboard, {
      fallbackErrorMessage: "Failed to load dashboard",
      onFulfilled: (state, action) => {
        state.data = action.payload;
        const routeId = action.meta?.arg != null ? String(action.meta.arg) : null;
        const title = getWorkspaceTitleFromDashboardApiPayload(action.payload);
        if (routeId && title) {
          state.workspaceProjectId = routeId;
          state.workspaceProjectName = title;
        }
      },
    });
  },
});

export const { clearProjectDashboard, seedWorkspaceProjectTitle } = projectDashboardSlice.actions;
export const selectProjectDashboardData = (state) => state.projectDashboard.data;
export const selectProjectDashboardLoading = (state) => state.projectDashboard.loading;
export const selectProjectDashboardError = (state) => state.projectDashboard.error;
export const selectWorkspaceProjectName = (state) => state.projectDashboard.workspaceProjectName;
export const selectWorkspaceProjectId = (state) => state.projectDashboard.workspaceProjectId;

export default projectDashboardSlice.reducer;
